"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ProgressIndicator = ({
  radius,
  stroke,
  progress,
  showPercentage,
  label,
  trackColor,
  barColor,
  ...otherProps
}) => {
  const percentage = progress <= 100 ? progress : 0;
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - percentage / 100 * circumference;
  const progressValue = `${Math.floor(percentage)}%`;
  const progressComplete = progress >= 100 ? true : undefined;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledProgressIndicator, {
    className: "rui-progress-indicator",
    radius: radius,
    "data-progress-indicator-complete": progressComplete,
    ...otherProps,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ProgressIndicatorChart, {
      radius: radius,
      children: [showPercentage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ProgressIndicatorChartLabel, {
        className: "rui-progress-indicator__value",
        "data-progress-indicator-value": true,
        children: progressValue
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
        radius: radius,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ProgressIndicatorChartTrack, {
          className: "rui-progress-indicator__track",
          fill: "transparent",
          strokeWidth: stroke,
          r: normalizedRadius,
          cx: radius,
          cy: radius,
          trackColor: trackColor
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ProgressIndicatorChartBar, {
          className: "rui-progress-indicator__bar",
          fill: "transparent",
          strokeWidth: stroke,
          strokeDasharray: circumference + ' ' + circumference,
          style: {
            strokeDashoffset
          },
          r: normalizedRadius,
          cx: radius,
          cy: radius,
          barColor: barColor
        })]
      })]
    }), label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ProgressIndicatorLabel, {
      className: "rui-progress-indicator__label",
      "data-progress-indicator-label": true,
      children: label
    })]
  });
};

ProgressIndicator.propTypes = {
  progress: _propTypes.default.number,
  radius: _propTypes.default.number,
  stroke: _propTypes.default.number,
  showPercentage: _propTypes.default.bool,
  label: _propTypes.default.string,
  trackColor: _propTypes.default.string,
  barColor: _propTypes.default.string,
  labelColor: _propTypes.default.string
};
ProgressIndicator.defaultProps = {
  progress: 0,
  radius: 60,
  stroke: 6,
  showPercentage: true,
  label: 'Loading...',
  trackColor: undefined,
  barColor: undefined,
  labelColor: undefined
};
var _default = ProgressIndicator;
exports.default = _default;